import { render, staticRenderFns } from "./NotRouterList.vue?vue&type=template&id=72c636c8&scoped=true&"
import script from "./NotRouterList.vue?vue&type=script&lang=js&"
export * from "./NotRouterList.vue?vue&type=script&lang=js&"
import style0 from "./NotRouterList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotRouterList.vue?vue&type=style&index=1&id=72c636c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c636c8",
  null
  
)

export default component.exports